import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { mergeMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators';
import { SchedulingService } from '../services/schedule.service';
import * as ScheduleUiSettingsActions from '../actions/schedule-ui-settings.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectScheduleUiSettings } from '../selectors/schedule-ui-settings.selectors';

@Injectable()
export class ScheduleUiSettingsEffects {
    constructor(
        private actions$: Actions, 
        private schedulingService: SchedulingService, 
        private store: Store<AppState>
    ) { }

    loadScheduleUiSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ScheduleUiSettingsActions.loadScheduleUiSettings),
            withLatestFrom(this.store.select(selectScheduleUiSettings)),
            filter(([action, existingUiSettings]) => !existingUiSettings),
            mergeMap(([{ organizationId }]) =>
                this.schedulingService.getScheduleUiSettings(organizationId).pipe(
                    map(uiSettings => {
                        return ScheduleUiSettingsActions.loadScheduleUiSettingsSuccess({ uiSettings });
                    }),
                    catchError(error => of(ScheduleUiSettingsActions.loadScheduleUiSettingsFailure({ error })))
                )
            )
        )
    );
}
